import React from 'react';
import { Container } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

export function ViewError({ message }: { message: string }) {
  return (
    <Container
      style={{
        background: '#f7f9ff',
        display: 'flex',
        alignItems: 'center',
        padding: 16,
      }}
      maxWidth="sm"
    >
      <Alert severity="error" style={{ width: '100%' }}>
        <strong>Error:</strong> {message}
      </Alert>
    </Container>
  );
}
